import { render } from "./Plotly.vue?vue&type=template&id=22997abc"
import script from "./Plotly.vue?vue&type=script&lang=js"
export * from "./Plotly.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__